/**=========================================================
 * Module: zip.js
 * Zip download Controller
 =========================================================*/

 App.controller('ZipController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$sce', '$element', 'ngDialog', '$http',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $sce, $element, ngDialog, $http) {
   "use strict";

   
   

    
    $scope.zipFilename += '.zip'

    let hash = (9999999999999 - new Date().getTime()) + $scope.type + $scope.field + ($scope.entity || $scope.parentid) + $rootScope.user.id

    let filter = 'type=' + $scope.type 
        + '&field=' + $scope.field 
        + ($scope.entity ? '&entityId=' + $scope.entity : '')
        + ($scope.parentid ? '&parentId=' + $scope.parentid : '')
        + ($scope.extension ? '&extension=' + $scope.extension : '') 
        + '&_filename=' + ($scope.zipFilename || 'AqrateFiles')
        + '&_rtHash=' + hash
        + '&access_token=' + $rootScope.FB.token

    $scope.zipPath = $rootScope.app.config.basicUrl + '/File.zip' + '?' + filter

    $scope.zipIcon = 'aqi-file-zip'

    $scope.getZip = function(){
        
        let a = document.createElement("a")
        a.href = $scope.zipPath;
        a.download = $scope.zipFilename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
            document.body.removeChild(a); 
        }, 0); 
        $scope.zipIcon = 'aqi-action-loading'
        FIREBASE.listen('File', hash, function(value){
            if(value){
                if(value.finished){
                    $timeout(function(){
                        $scope.zipIcon = 'aqi-action-download'
                        $scope.zipProgress = ''
                    }, 0)
                } else if(value.error){
                    $timeout(function(){
                        $scope.zipIcon = 'aqi-result-error text-danger'
                        $scope.zipProgress = 'Error'
                    }, 0)
                } else {
                    $timeout(function(){
                        $scope.zipProgress = value.totalFilesDone + '/' + value.totalFiles + ' - ' + Math.round(value.totalBytes/value.totalSize*100) + '%'
                    }, 0)
                }
            }
        }, null, { interval: 10000 })
    }

    
    $scope.openInfo = function(){
        $scope.showInfo = true
    }

    $scope.listenToJob = function(jobId){
        FIREBASE.listen('jobs', jobId, function(value){
            if(value.status=='completed'){
                $timeout(function(){
                    $scope.zipIcon = 'aqi-action-download'
                    $scope.zipProgress = ''
                    $scope.zipUrl = value.result.file
                    $scope.job = value
                    $scope.estimatedEnd = 0
                    if(!$scope.noAutoDownload){
                        let a = document.createElement("a")
                        a.href = value.result.file;
                        a.download = $scope.zipFilename;
                        document.body.appendChild(a);
                        a.click();
                        setTimeout(function() {
                            document.body.removeChild(a); 
                        }, 0); 
                    }
                }, 0)
            } else if(value.status=='running'){
                //$scope.showInfo = true
                $timeout(function(){
                    $scope.job = value
                    $scope.zipProgress = value.progress.current + '/' + value.progress.total + ' - ' + Math.round(value.progress.size ? value.progress.size/value.progress.totalSize*100 : value.progress.current/value.progress.total*100) + '%'
                }, 0)
            } else if(value.status=='failed'){
                $timeout(function(){
                    $scope.job = value
                    $scope.estimatedEnd = 0
                    $scope.error = value.error
                    $scope.showInfo=true
                }, 0)
            }
        }, function(err){
            $timeout(function(){
                $scope.job = value
                $scope.estimatedEnd = 0
                $scope.error = err
                $scope.showInfo=true
            }, 0)
        }, { noRT: true })
    }

    $scope.zipping = false
    $scope.zipJob = function(){
        if($scope.zipUrl) return
        if($scope.zipping) {$scope.showInfo=true; return}
        $scope.zipping = true
        $scope.zipIcon = 'aqi-action-loading'
        D.save('job', {
            id: $scope.action ? $scope.action : 'ZipFiles',
            field: $scope.field,
            type: $scope.type,
            entityId: $scope.entity,
            parentId: $scope.parentid,
            extension: $scope.extension,
            filename: $scope.zipFilename,
            bucket: $scope.bucket
        }).then(function(response){
            if(response.data.jobId){
                $scope.listenToJob(response.data.jobId)
            } else if(response.data.jobs){
                $scope.listenToJob(response.data.jobs[0])
            }
        }).catch(function(err){
            $scope.zipIcon = 'aqi-result-error text-danger'
            $scope.error = err
            $scope.zipping = false
            $scope.showInfo=true
        })
    }

    if($scope.jobId){
        $scope.zipping = true
        $scope.listenToJob($scope.jobId)
    }

    $scope.$watch('files', function(value){
        $scope.zipIcon = 'aqi-file-zip'
        $scope.zipUrl = ''
        $scope.zipping = false
    })


 }
 ]);
